import localforage from 'localforage';

const localstore = localforage.createInstance({
    name: "DirectiononMicrosoft",
    version: 1,
    storeName: "appLocalStore",
    driver: localforage.LOCALSTORAGE,
});

export { localstore };
